<template>
  <el-card class="box-card" ref="card">
    <div slot="header" class="clearfix">
      <span>行业品牌合作维度
        <span style="font-weight: lighter;font-size: 10px">（{{ condition.year }}年{{ condition.month }}月
        <el-tooltip class="item" effect="dark"
                    :content="`统计数据来源：${condition.year}年${condition.month}月内下单的订单`" placement="top-start">
                <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
        </el-tooltip>）</span>
      </span>
      <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
               title="点击刷新" @click="getData">
        <i class="el-icon-refresh-right"/>
      </el-link>
      <el-button style="float: right; margin-left: 10px;" size="mini" type="primary" plain icon="el-icon-upload2"
                 @click="$refs.feishuSyncDialog.open('brand_trade')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      <summary-export-link style="float: right" filename="行业品牌合作"
                           :params="{...{tag: 'brandTrade'},...condition}"/>
    </div>
    <el-table class="dashboard-table"
              show-summary
              :summary-method="getSummaries"
              :data="data"
              :row-style="{ border: 'none',padding:'15px 0'}"
              :cell-style="{ border: 'none'}"
              @sort-change="sortChange"
              style="width: 100%" v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading">
      <el-table-column prop="trade_name" label="行业" align="center"/>
      <el-table-column prop="order_money" :label="`订单金额(元)`" align="right"
                       header-align="right" sortable="custom">
        <template slot-scope="scope">
          <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_percent_money" :label="`订单金额占比`" align="right" header-align="right">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_money, 1) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="brand_count" label="品牌数量" align="right" header-align="right" sortable="custom">
        <template slot-scope="scope">
          <span>{{ scope.row.brand_count }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="brand_percent_count" :label="`品牌数量占比`" align="right" header-align="right">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.brand_percent_count, 1) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <feishu-sync-dialog ref="feishuSyncDialog" :scopes="syncScopes" :condition="condition"/>
  </el-card>
</template>

<script>
import {getDashboardBrandTrade} from "@/api/dashboard";
import {
  feishuBrandTradeSyncConfig,
  saveFeishuBrandTradeSyncConfig,
  feishuSyncBrandTrade
} from "@/api/feishu";
import FeishuSyncDialog from "@/components/summary/FeishuSyncDialog.vue";
import SummaryExportLink from "@/components/summary/ExportLink.vue";

// 「同步到飞书」维度配置（共用 FeishuSyncDialog）
const SYNC_SCOPES = {
  brand_trade: {
    label: '行业品牌合作维度',
    entity: '行业品牌合作',
    rowHint: '每个行业写入一条记录',
    getConfig: feishuBrandTradeSyncConfig,
    saveConfig: saveFeishuBrandTradeSyncConfig,
    sync: feishuSyncBrandTrade
  }
}

export default {
  name: "SummaryBrandTrade",
  components: {SummaryExportLink, FeishuSyncDialog},
  inject: ['condition'],
  data() {
    return {
      // 同步到飞书：维度配置（共用 FeishuSyncDialog）
      syncScopes: SYNC_SCOPES,
      loading: false,
      queryOrder: '',
      queryProp: '',
      data: [],
      brandRealCount: 0,
    }
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    // 处理搜索条件
    handleSearchCondition() {
      let params = {...{}, ...this.condition}
      params = {...params, ...{queryOrder: this.queryOrder, queryProp: this.queryProp}}
      return params
    },
    getData() {
      this.loading = true;
      this.data = [];
      const searchCondition = this.handleSearchCondition()
      getDashboardBrandTrade(searchCondition).then(res => {
        this.loading = false;
        this.data = res.model.data;
        this.brandRealCount = res.model.brand_real_count;
      })
    },
    sortChange({prop, order}) {
      this.queryOrder = order === "descending" ? 'desc' : 'asc'
      this.queryProp = prop
      this.getData()
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_percent_money', 'brand_count', 'brand_percent_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "brand_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
            case "brand_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + `（去重后${this.brandRealCount}）`;
              break;
          }
        }
      });
      return sums
    }
  }
}
</script>

<style>
.caret-wrapper {
  width: 8px !important;
}

</style>
